module.exports = __webpack_public_path__ + "static/media/background.c21095dd.png";